module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "d-footer"
  }, [_c('div', {
    staticClass: "top"
  }, [_vm._m(0), _c('div', {
    staticClass: "center"
  }, [_c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('router-link', {
    attrs: {
      "to": "/index"
    }
  }, [_c('span', [_vm._v("关于懂窝")])])], 1), _c('div', {
    staticClass: "lable",
    on: {
      "click": function($event) {
        return _vm.clickLable('brand-desc')
      }
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/index?scrollEl=brand-desc"
    }
  }, [_c('span', [_vm._v("品牌介绍")])])], 1), _c('div', {
    staticClass: "lable",
    on: {
      "click": function($event) {
        return _vm.clickLable('module3')
      }
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/index?scrollEl=module3"
    }
  }, [_c('span', [_vm._v("产品介绍")])])], 1), _c('div', {
    staticClass: "lable",
    on: {
      "click": function($event) {
        return _vm.clickLable('module5')
      }
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/index?scrollEl=module3"
    }
  }, [_c('span', [_vm._v("合作工厂")])])], 1), _c('div', {
    staticClass: "lable",
    on: {
      "click": function($event) {
        return _vm.clickLable('module12')
      }
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/index?scrollEl=module10"
    }
  }, [_c('span', [_vm._v("品牌合作伙伴")])])], 1)]), _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('router-link', {
    attrs: {
      "to": "/serviceRules"
    }
  }, [_c('span', [_vm._v("服务政策")])])], 1), _c('div', {
    staticClass: "lable",
    on: {
      "click": function($event) {
        return _vm.clickLable('module5')
      }
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/index?scrollEl=module5"
    }
  }, [_c('span', [_vm._v("服务特色")])])], 1), _c('div', {
    staticClass: "lable"
  }, [_c('router-link', {
    attrs: {
      "to": "/serviceRules?currentTab=1"
    }
  }, [_c('span', [_vm._v("配送说明")])])], 1), _c('div', {
    staticClass: "lable"
  }, [_c('router-link', {
    attrs: {
      "to": "/serviceRules?currentTab=2"
    }
  }, [_c('span', [_vm._v("售后服务")])])], 1), _c('div', {
    staticClass: "lable"
  }, [_c('router-link', {
    attrs: {
      "to": "/serviceRules?currentTab=3"
    }
  }, [_c('span', [_vm._v("常见问题")])])], 1)]), _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('router-link', {
    attrs: {
      "to": "/contactUs"
    }
  }, [_c('span', [_vm._v("联系我们")])])], 1), _c('div', {
    staticClass: "lable"
  }, [_c('router-link', {
    attrs: {
      "to": "/contactUs?currentTab=1"
    }
  }, [_c('span', [_vm._v("合作咨询")])])], 1), _c('div', {
    staticClass: "lable"
  }, [_c('router-link', {
    attrs: {
      "to": "/contactUs?currentTab=2"
    }
  }, [_c('span', [_vm._v("招聘信息")])])], 1)])]), _vm._m(1)]), _c('div', {
    staticClass: "bottom"
  }, [_vm._v("上海素造网络科技有限公司版权所有  |  沪ICP备19016235号  |   © Copyright 2019 All Rights Reserved")])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "left"
  }, [_c('img', {
    attrs: {
      "src": require("assets/footer/logo.png")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "right"
  }, [_c('div', {
    staticClass: "cont"
  }, [_c('img', {
    attrs: {
      "src": require("assets/footer/qrCode.jpg")
    }
  }), _c('p', [_vm._v("微信公众号")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6f78b2bf"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/footer.vue
// module id = 451
// module chunks = 0